<template>
    <ModalTemplate
        @close="$emit('close')"
        @openFilter="$emit('openFilter')"
        :darkOverlay="true"
        :closeBtn="true"
        :backToListBtn="true"
        :scrollBodyLock="true"
    >
        <LandPlotModalTop
            :landPlot="landPlot"
            @openInFullScreenPlotModalGallery="openInFullScreenPlotModalGallery"
            @close="$emit('close')"
        />
        <LandPlotModalBottom
            v-if="landPlot && landPlot.house"
            :landPlot="landPlot"
            @openInFullScreenHouseModalGallery="
                openInFullScreenHouseModalGallery
            "
        />
    </ModalTemplate>
</template>

<script setup lang="ts">
    import { ref, computed, watch } from 'vue';
    import ModalTemplate from '@/components/layouts/ModalTemplate.vue';
    import LandPlotModalTop from './LandPlotModalTop.vue';
    import LandPlotModalBottom from './LandPlotModalBottom.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';

    defineEmits(['close', 'openFilter']);

    const indexActiveSlider = ref(0);
    const isActivePlotModalGalleryFullScreen = ref(false);
    const isActiveHouseModalGalleryFullScreen = ref(false);

    const landPlot = computed(() => {
        return landPlotStore.LAND_PLOT_CARD_IN_MODAL;
    });

    function openInFullScreenPlotModalGallery(data: number) {
        indexActiveSlider.value = data;
        isActivePlotModalGalleryFullScreen.value = true;
    }

    function openInFullScreenHouseModalGallery(data: number) {
        indexActiveSlider.value = data;
        isActiveHouseModalGalleryFullScreen.value = true;
    }

    watch(isActivePlotModalGalleryFullScreen, value => {
        if (
            isActivePlotModalGalleryFullScreen.value ||
            isActiveHouseModalGalleryFullScreen.value
        )
            document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    });
</script>

<style lang="less"></style>
